var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.80918257 3.985h2.19081743v-3.816c-.3779685-.052-1.6778602-.169-3.19173402-.169-3.15873677 0-5.32255646 1.987-5.32255646 5.639v3.361h-3.48570952v4.266h3.48570952v10.734h4.27364387v-10.733h3.34472131l.5309557-4.266h-3.87667693v-2.939c.00099992-1.233.33297225-2.077 2.0508291-2.077z"}));
}

FacebookIcon.defaultProps = {"height":"24","viewBox":"0 0 12 24","width":"12"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
